// extracted by mini-css-extract-plugin
module.exports = {"line":"_Index_line_1IzAX","layout-color":"_Index_layout-color_2k0ps","down-icon":"_Index_down-icon_1KKgY","footer-image":"_Index_footer-image_yQQ3H"};